module.exports = __webpack_public_path__ + "public/img/qianyue.3a381675.png";